<template>
  <b-modal
      id="review-highlights-modal"
      centered
      size="lg"
      hide-footer
      lazy
      body-class="p-0"
  >
    <template #modal-title>
      <h5 class="modal-title font-18">
        <i class="bx bxs-chart"></i>
        {{ $t('pages.review.review_highlights.title') }}
      </h5>
    </template>
    <div>
      <b-tabs
          v-model="tab"
          id="highlights-tabs"
          pills
          justified
          content-class="p-3 text-muted"
      >
        <b-tab active v-for="(tab, index) in Object.values(tabs)" :key="index">
          <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i :class="tab.icon"></i>
                  </span>
            <span class="d-none d-sm-inline-block">
              <i :class="tab.icon"></i>
              {{ tab.text }}
            </span>
          </template>
          <b-card-body class="pt-0">
            <simplebar class="area">
              <div v-if="tab.data.length > 0">
                <div v-for="(comment,index) in tab.data" :key="index">
                  <div class="comment">
                    <div class="comment-text text-muted">
                      {{ comment.sum ? comment.sum : comment.review }}
                    </div>
                    <div class="pt-2">
                      <h4>
                    <span class="badge rounded py-2 mt-1"
                          :class="`badge-soft-${ ratingOptions[comment.rating].color}`">
                          <i :class=" ratingOptions[comment.rating].icon"></i>
                      {{ ratingOptions[comment.rating].text }}
                    </span>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <NoContent :loading="loading" height="240px"></NoContent>
              </div>
            </simplebar>
          </b-card-body>
        </b-tab>
      </b-tabs>
    </div>
  </b-modal>

</template>

<script>
import simplebar from "simplebar-vue";
import ProductService from "../../../../Services/Api/ProductService";

export default {
  name: "ReviewHighlights",
  components: {simplebar},
  props: ['selectedProduct'],
  data() {
    return {
      loading: false,
      tab: 0,
      ratingOptions: {
        1: {
          icon: 'bx bxs-dislike',
          color: 'danger',
          text: this.$t('pages.review.review_highlights.reviews.negative')
        },
        2: {
          icon: 'bx bxs-dislike',
          color: 'danger',
          text: this.$t('pages.review.review_highlights.reviews.negative')
        },
        3: {
          icon: 'bx bx-dots-horizontal-rounded',
          color: 'warning',
          text: this.$t('pages.review.review_highlights.reviews.neutral')
        },
        4: {
          icon: 'bx bxs-like',
          color: 'success',
          text: this.$t('pages.review.review_highlights.reviews.positive')
        },
        5: {
          icon: 'bx bxs-like',
          color: 'success',
          text: this.$t('pages.review.review_highlights.reviews.positive')
        }
      },
      tabs: {
        quality: {
          text: this.$t('pages.review.review_highlights.classes.quality'),
          icon: 'bx bxs-badge-check',
          data: []
        },
        price: {
          text: this.$t('pages.review.review_highlights.classes.price'),
          icon: 'bx bxs-wallet',
          data: []
        },
        shipping: {
          text: this.$t('pages.review.review_highlights.classes.shipping'),
          icon: 'bx bxs-truck',
          data: []
        },
        competitiveness: {
          text: this.$t('pages.review.review_highlights.classes.competitiveness'),
          icon: 'bx bxs-shopping-bag',
          data: []
        },
        packaging: {
          text: this.$t('pages.review.review_highlights.classes.packaging'),
          icon: 'bx bxs-package',
          data: []
        }
      }
    }
  },
  watch: {
    selectedProduct() {
      this.getReviews()
    }
  },
  methods: {
    clearData() {
      for (const tab in this.tabs) {
        this.tabs[tab].data = [];
      }
    },
    async getReviews() {
      this.clearData()
      this.loading = true
      const {data: reviews} = await ProductService.getReviewHighlights({id: this.selectedProduct, query: ''})

      reviews.data.forEach(review => {
        if(review.class) {
          this.tabs[review.class.toLowerCase()].data.push(review)
        }
      })

      this.loading = false
    }
  }
}
</script>

<style scoped>
#highlights-tabs /deep/ .nav-link {
  padding: 6px 0 6px 0;
}

#highlights-tabs /deep/ .nav {
  background-color: #fafafa;
  border-radius: 0.25rem;
  -moz-box-shadow: inset 0 0 8px #f3f3f3;
  -webkit-box-shadow: inset 0 0 8px #f3f3f3;
  box-shadow: inset 0 0 8px #f3f3f3;
}

.comment {
  padding: 15px 0 15px 0 !important;
  border-top: 1px solid #F0F0F0 !important;
}

.comment-text {
  font-size: 15px !important;
  line-height: 22px !important;
  text-align: left !important;
}

.area {
  height: 300px !important;
}

</style>